import { ErrorHandler, Injectable, NgZone, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslocoService } from '@jsverse/transloco';
import { NotificationService } from './services/notification.service';
import { AppVersionService } from './services/app-version.service';

// A tab opened before a deploy asks for chunks the new container no longer has (Chrome, Safari, Firefox wording).
const CHUNK_LOAD_FAILURE =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/;

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly _notificationService = inject(NotificationService);
  private readonly _appVersionService = inject(AppVersionService);
  private readonly _transloco = inject(TranslocoService);
  private readonly _zone = inject(NgZone);

  handleError(error: unknown): void {
    if (error instanceof HttpErrorResponse) {
      console.error(
        'HTTP error caught by GlobalErrorHandler (should be handled by Interceptor):',
        error,
      );
      return;
    }

    if (error instanceof Error && CHUNK_LOAD_FAILURE.test(error.message)) {
      this._zone.run(() => this._appVersionService.promptReload());
      return;
    }

    console.error('Caught by GlobalErrorHandler:', error);

    this._zone.run(() => {
      this._notificationService.show(
        this._transloco.translate('errors.generic'),
      );
    });
  }
}
